export default {
  "root": "_root_1r0q6_1",
  "table": "_table_1r0q6_1",
  "row": "_row_1r0q6_1",
  "cell": "_cell_1r0q6_1",
  "head": "_head_1r0q6_1",
  "body": "_body_1r0q6_1",
  "cell--align-start": "_cell--align-start_1r0q6_1",
  "cell--align-center": "_cell--align-center_1r0q6_1",
  "cell--align-end": "_cell--align-end_1r0q6_1",
  "cell--valign-start": "_cell--valign-start_1r0q6_1",
  "cell--valign-center": "_cell--valign-center_1r0q6_1",
  "cell--valign-end": "_cell--valign-end_1r0q6_1",
  "cell--width-auto": "_cell--width-auto_1r0q6_1",
  "--row-highlighted": "_--row-highlighted_1r0q6_1",
  "--border-outer": "_--border-outer_1r0q6_1",
  "--border-column": "_--border-column_1r0q6_1",
  "--fade-start": "_--fade-start_1r0q6_1",
  "--fade-end": "_--fade-end_1r0q6_1"
};import "ni:sha-256;fZBUYAhCZmO3jNyMDALoooR8fkut_QVGqu46v3yhQKs";